(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.custom-video-text').forEach(section => {

    const modal = section.querySelector('.video-modal');
    const openBtn = section.querySelector('.video-preview');

    if (!modal || !openBtn) return;

    const closeBtn = modal.querySelector('.video-modal__close');
    const overlay = modal.querySelector('.video-modal__overlay');

    function openModal() {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';

      const video = modal.querySelector('video');

      if (video) {
        video.currentTime = 0;
        video.play();
      }

      const iframe = modal.querySelector('iframe');

      if (iframe) {
        const src = iframe.dataset.src || iframe.src;

        if (!iframe.dataset.src) {
          iframe.dataset.src = src;
        }

        if (src.includes('youtube')) {
          iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
        } else if (src.includes('vimeo')) {
          iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
      }
    }

    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';

      const video = modal.querySelector('video');

      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      const iframe = modal.querySelector('iframe');

      if (iframe) {
        iframe.src = iframe.dataset.src;
      }
    }

    openBtn.addEventListener('click', openModal);

    closeBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
